// extracted by mini-css-extract-plugin
module.exports = {"dropdown-pre-icon":"HeaderDropdown_dropdown-pre-icon__1t7ry","dropdownOuter":"HeaderDropdown_dropdownOuter__3wRsg","MuiMenu-paper":"HeaderDropdown_MuiMenu-paper__2iUD6"};